import { createApp } from 'vue'
import App from './layout/App.vue'
import router from './router'
import commonHeader from './components/commonHeader.vue'
import commonFooter from './components/commonFooter.vue'
import './assets/css/app.css'
import axios from 'axios'
import { routeServiceRequest } from './utils/apiConfig.js'


const app = createApp(App)

app.component('common-header', commonHeader)
app.component('common-footer', commonFooter)
axios.defaults.baseURL = 'https://pms.lexcode.co.kr' //실서버용 주소
axios.interceptors.request.use(routeServiceRequest)
app.provide('$axios', axios)
app.use(router)

app.mount('#app')
